import React, { memo } from 'react';
import { SvgUniqueID } from '@financial/svg-manager';

const IconBackButtonBoldSemi = /*#__PURE__*/memo(_ref => {
  let {
    fill = '#222',
    width = '100%',
    height = '100%',
    viewBox = '0 0 20 18',
    id,
    style = {}
  } = _ref;
  return /*#__PURE__*/React.createElement(SvgUniqueID, {
    id: id
  }, /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    style: style
  }, /*#__PURE__*/React.createElement("g", {
    stroke: fill,
    strokeWidth: "1.5",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.98 8L19 8",
    transform: "translate(-17 -93) translate(0 74) translate(18 20)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M8.521 0L0.5 8.021 8.521 16",
    transform: "translate(-17 -93) translate(0 74) translate(18 20)"
  }))));
});

export { IconBackButtonBoldSemi as default };
